import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-sin-display-field',
  templateUrl: './sin-display-field.component.html',
  styleUrls: ['./sin-display-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SinDisplayFieldComponent {
  @Input() sin!: string;

  private _showFullSin = new BehaviorSubject(false);
  public showFullSin$ = this._showFullSin as Observable<boolean>;

  public iconSrc$ = this.showFullSin$.pipe(
    map(showFullSin => {
      return showFullSin
        ? '/assets/icons/transparent-backgrounds/Eye On.svg'
        : '/assets/icons/transparent-backgrounds/Eye Off.svg';
    })
  );

  public toggleShowFullSin(): void {
    this.showFullSin$.once(masked => this._showFullSin.next(!masked));
  }
}
